var module = angular.module('octopusApp.certificates');

module.directive('certificateSelect', function() {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/certificates/select/certificate_select.html',
        scope: {
            selectedId: '=',
            onChange: '=',
            tenantId: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: function($scope, busy, octopusRepository, $uibModal) {

            var vm = this;

            vm.isLoading = busy.create();

            $scope.$watch('vm.selectedId', function(newVal, oldVal) {
                if (newVal) {
                    vm.isLoading.promise(octopusRepository.Certificates.get(vm.selectedId).then(function(certificate){
                        vm.selected = certificate;
                    }));
                }
            });

            vm.displayText = function() {
               return vm.selected ? vm.selected.Name : 'Select certificate...';
            };

            vm.select = function() {
               $uibModal.open({
                   size: "lg",
                   controller: 'CertificateSelectModalController',
                   controllerAs: 'vm',
                   bindToController: true,
                   templateUrl: 'areas/certificates/select/certificate_select_modal.html',
                   resolve: {
                       selectedId: function(){ return vm.selectedId; },
                       tenantId: function() {return vm.tenantId; }
                   }
               }).result.then(function(result) {
                   if (!result) {
                       return;
                   }
                   //vm.selectedId = result;
                   vm.onChange(result);
               });
            };
        }
    };
});

module.controller('CertificateSelectModalController', function(selectedId, tenantId, $uibModalInstance, $location) {
    var vm = this;
    vm.selectedId = selectedId;
    vm.tenantId = tenantId;

    vm.certificatesEmpty = false;

    vm.cancel = $uibModalInstance.close;

    vm.onSelect = function(certificateId) {
        $uibModalInstance.close(certificateId);
    };

    vm.gotoCertificates = function() {
        $location.path("/library/certificates");
        vm.cancel();
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/certificates/select/certificate_select.js
// module id = 8790175632902091
// module chunks = 1